module.exports = __webpack_public_path__ + "bcd41d005466dcf756a3a60962de1929.png";